module.exports = __webpack_public_path__ + "b6f01ddafa77d1515f4b1186f640bb84.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bonds-issue-circle-1.png
// module id = 1614
// module chunks = 0